<template>
  <div class="offDetial">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">{{ Form.title || '' }}</div>
        <blank height="7"></blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">公文发文审批流程</div>
        <blank height="7"></blank>
        <a-button
          v-if="Form.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
          >打印</a-button
        >
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="公文详情" />
        <a-tab-pane
          key="2"
          tab="审批流程"
          v-if="Form.state > 0 && version == ''"
        />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">公文拟稿</div>
      <blank height="15"></blank>
      <div class="newsDetial-abstract">
        请按照文本要求草拟公文，并提交进行流程审批
      </div>
      <blank height="45"></blank>
    </div>
    <div class="detial-cont" v-show="tabnum == 1">
      <div class="detial-cont-title">
        公文文稿信息
        <a-button
          v-show="id && Form.state != 4"
          :loading="WorkLoading"
          class="title-btn"
          type="primary"
          icon="play-circle"
          @click="createWork"
        >
          预览</a-button
        >
      </div>
      <blank height="1"></blank>
      <div class="detial-cont-view">
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">
              标题
              <span class="required">*</span>
            </span>
            <a-input
              class="w500"
              placeholder="请添加标题"
              v-model="Form.title"
              :disabled="disabled"
              @change="eightyfive('title')"
            />
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">
              发文类别
              <span class="required">*</span>
            </span>
            <a-select
              placeholder="请选择发文类别"
              class="w300"
              v-model="Form.dispatchType"
              :disabled="disabled"
              @change="dispatchTypeChange"
            >
              <a-select-option :value="1">行政</a-select-option>
              <a-select-option :value="2">党工团</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 发文分类 </span>
            <a-select
              placeholder="请选择发文分类"
              class="w300"
              v-model="Form.dispatchClassify"
              :disabled="disabled"
            >
              <a-select-option
                v-for="item in documentTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">
              发文编号类别
              <span class="required">*</span>
            </span>
            <a-select
              placeholder="请选择发文编号类别"
              class="w300"
              v-model="Form.serialNumberType"
              :disabled="disabled"
              @change="serialNumberTypeChange"
            >
              <a-select-option value="1">编号文</a-select-option>
              <a-select-option value="2">非编号文</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 发文编号 </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.serialNumber"
              @change="eightyfive('serialNumber')"
              :disabled="Form.serialNumberType != 1 || disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">
              发文单位 <span class="required">*</span></span
            >
            <a-tooltip placement="topLeft" :title="Form.companyName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.companyName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  :disabled="disabled"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>

          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 拟稿人 </span>
            <a-select
              placeholder="请选择拟稿人"
              class="w300"
              v-model="Form.drafter"
              :disabled="true"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 签发 </span>
            <a-select
              placeholder="请添加"
              class="w300"
              v-model="Form.signer"
              :disabled="true"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id + ''"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">
              页头
              <span class="required">*</span>
            </span>

            <a-select
              class="w300"
              placeholder="请选择页头"
              v-model="Form.pageHead"
              :disabled="disabled"
            >
              <a-select-option
                v-for="item in sysHeaderListData"
                :key="item.id"
                :value="item.header"
                >{{ item.header }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 套红 </span>
            <a-select
              placeholder="请添加"
              class="w300"
              v-model="Form.redChromatography"
              :disabled="true"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id + ''"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace"> 发文日期 </span>
            <a-date-picker
              class="w300"
              v-model="Form.launchDate"
              :valueFormat="dateFormat"
              :disabled="disabled"
            />
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"> 紧急程度 </span>
            <a-select
              placeholder="请选择"
              class="w200"
              v-model="Form.emergencyDegree"
              :disabled="disabled"
            >
              <a-select-option value="1">紧急</a-select-option>
              <a-select-option value="2">一般</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace">
              发文份数
              <span class="required">*</span>
            </span>
            <a-input-number
              :min="0"
              :max="999999999"
              class="w200"
              placeholder="请添加"
              v-model="Form.postNumber"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"> 资料等级 </span>
            <a-select
              placeholder="请选择"
              class="w200"
              v-model="Form.classified"
              :disabled="disabled"
            >
              <a-select-option :value="10">普通</a-select-option>
              <a-select-option
                :value="100"
                :disabled="userInfo.secretLevel == 10"
                >重要</a-select-option
              >
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">
              主送
              <span class="required">*</span>
            </span>
            <a-select
              mode="multiple"
              placeholder="请添加"
              class="w500"
              :filter-option="filterOption"
              v-model="Form.groupIds"
              :disabled="disabled"
            >
              <a-select-option
                v-for="i in GroupList"
                :value="i.id"
                :key="i.id"
                >{{ i.groupName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="3" v-show="Form.state == 2">
            <span slot="label" class="whiteSpace">浏览数据 </span>
            <div v-show="Form.state == 2">
              <a-row type="flex">
                <a-col :span="8"
                  >通知人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(1)"
                    >{{ personalCounts.noticeCount }}</span
                  >人
                </a-col>
                <a-col :span="8"
                  >已传阅人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(2)"
                    >{{ personalCounts.circulate }}</span
                  >人
                </a-col>
                <a-col :span="8"
                  >未传阅人数：<span
                    class="personNumber"
                    @click="lookPersonNumber(3)"
                  >
                    {{ personalCounts.notCirculate }}</span
                  >人
                </a-col>
              </a-row>
            </div>
          </a-descriptions-item>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">
              内容
              <span class="required">*</span>
            </span>
            <div class="edui-default">
              <prompts>
                友情提示
                <div slot="two">
                  1.关于图片，设置最佳的图片尺寸为475px,等比例缩放，格式为居中，调整图片大小请使用鼠标拖动或点击图片进行修改设置；<br />
                  <blank height="5"> </blank>
                  2.关于字体大小，请选择富文本编辑器的字体大小，从其他粘贴过来的字体有可能会造成与系统字体不匹配的情况，请对粘贴过来的字体重新设置字体大小。
                  <blank height="8"> </blank>
                </div>
              </prompts>
              <blank height="15"> </blank>
              <template>
                <script id="editor" ref="ueditor" type="text/plain"></script>
                <blank height="15"> </blank>
              </template>
            </div>
          </a-descriptions-item>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace"> 附件 </span>
            <!-- 附件 -->
            <div class="fileDiv">
              <div class="fileDiv-left">
                <div v-for="(record, index) in upfileList" :key="index">
                  <a-button type="link">{{
                    record.filename + '.' + record.fileformat
                  }}</a-button>
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="goDetial(record)"
                    >查看</a-button
                  >
                  <a-divider type="vertical" />
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="
                      download(
                        record.mongoFileId,
                        record.filename,
                        record.fileformat
                      )
                    "
                    >下载</a-button
                  >
                  <template v-if="!disabled">
                    <a-divider type="vertical" />
                    <a-button
                      type="link"
                      class="btn-link"
                      @click="removeFiles(index)"
                      >删除</a-button
                    >
                  </template>
                </div>
              </div>
              <div>
                <a-upload
                  v-if="!disabled"
                  name="file"
                  :multiple="false"
                  :headers="headers"
                  action="#"
                  @change="uploadFiles"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                >
                  <a-button icon="plus">添加附件</a-button> </a-upload
                >支持扩展名：.rar .zip .doc .docx .pdf .jpg...
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"></blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回</a-button
        >
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <!-- v-if="!Form.state && !disabled" -->
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/documentIssuance/details?id="
      skipPageReqFlag="/OfficialDocumentDetial"
    >
      <div class="Oprintd-title">北京民政工业总公司公文发文审批表</div>
      <div class="Oprintd-cont offDetial">
        <div class="Oprintd-item">
          <div class="Oprintd-td">
            <a-descriptions bordered size="small">
              <a-descriptions-item label="公文标题" :span="3">
                {{ Form.title }}
              </a-descriptions-item>
              <a-descriptions-item label="发文类别" :span="1.5">
                <span v-if="Form.dispatchType == 1">行政</span>
                <span v-if="Form.dispatchType == 2">党工团</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文分类" :span="1.5">
                {{ getByTypeName(Form.dispatchClassify, documentTypeList) }}
              </a-descriptions-item>
              <a-descriptions-item label="发文编号类别" :span="1.5">
                <span v-if="Form.serialNumberType == 1">编号文</span>
                <span v-if="Form.serialNumberType == 2">非编号文</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文编号" :span="1.5">
                {{ Form.serialNumber }}
              </a-descriptions-item>
              <a-descriptions-item label="发文单位" :span="1.5">
                {{ Form.companyName }}
              </a-descriptions-item>
              <a-descriptions-item label="拟稿人" :span="1.5">
                {{ Form.drafterName }}
              </a-descriptions-item>
              <a-descriptions-item label="签发" :span="1.5">
                <span v-for="i in queryUserList" :key="i.id">
                  <span v-if="i.id == Form.signer">{{ i.fullName }}</span>
                </span>
              </a-descriptions-item>
              <a-descriptions-item label="页头" :span="1.5">
                {{ Form.pageHead }}
              </a-descriptions-item>
              <a-descriptions-item label="套红" :span="1.5">
                <span v-for="i in queryUserList" :key="i.id">
                  <span v-if="i.id == Form.redChromatography">{{
                    i.fullName
                  }}</span>
                </span>
              </a-descriptions-item>
              <a-descriptions-item label="拟稿日期" :span="1.5">
                {{ Form.createTime }}
              </a-descriptions-item>

              <a-descriptions-item label="紧急程度" :span="1">
                <span v-if="Form.emergencyDegree == 1">紧急</span>
                <span v-if="Form.emergencyDegree == 2">一般</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文份数" :span="1">
                {{ Form.postNumber }}
              </a-descriptions-item>
              <a-descriptions-item label="资料等级" :span="1">
                <span v-if="Form.classified == 10">普通</span>
                <span v-if="Form.classified == 100">重要</span>
              </a-descriptions-item>
              <a-descriptions-item label="主送" :span="3">
                <span v-for="(i, index0) in Form.groupIds" :key="index0">
                  <span v-for="v in GroupList" :key="v.id">
                    <span v-if="i == v.id" class="Oprintd-item-span">{{
                      v.groupName
                    }}</span>
                  </span>
                </span>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <div class="Oprintd-item-gw">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns2"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
    <a-modal v-model="visible" title="浏览数据" :footer="null" :width="800">
      <a-table
        :pagination="false"
        :columns="LookColumns"
        :data-source="LookList"
        :row-key="(record) => record.id"
        :loading="lookloadIng"
      >
        <span slot="index" slot-scope="text, record, index">{{
          index + 1 + (page - 1) * 10
        }}</span>
        <span slot="documentConsultStatus" slot-scope="text">{{
          text == 1 ? '已传阅' : '未传阅'
        }}</span>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
let vm = this
import {
  officialDocumentSave,
  officialDocumentGet,
  officialDocumentUpdate,
  getUserIds,
  sysHeaderList,
  createWord,
  getHistoryVersion,
  getPersonalCounts
} from './api/api'

import { mapState, mapActions } from 'vuex'
import { saveFile, getFile } from '@/http/url'
import { getSuffix, formatDate, formatDateNoDetails } from '@/assets/js/auth'
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
export default {
  components: {
    approvalSubmission,
    approvalChart
  },
  data() {
    return {
      tabnum: '1',
      Form: {},
      headers: {
        Authentication: localStorage.getItem('token')
      },
      upfileList: [], //公文附件列表
      dateFormat: 'YYYY-MM-DD',
      serialNumberState: true,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      sysHeaderListData: [],
      confirmLoading: false,
      loading: false, // 限制多次点击
      WorkLoading: false,
      // 富文本
      editor: null,
      editorContent: '',
      isDisabledTrue: true,
      version: '',
      formDTOList: [],
      isPrint: false, // 打印弹窗
      columns2: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'center'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        }
      ],
      workbench: '',
      personalCounts: {}, //浏览数据
      visible: false,
      LookColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '状态',
          dataIndex: 'documentConsultStatus',
          key: 'documentConsultStatus',
          scopedSlots: { customRender: 'documentConsultStatus' },
          align: 'center'
        },
        {
          title: '部门',
          dataIndex: 'organizationName',
          key: 'organizationName',
          align: 'cneter'
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          key: 'userName',
          align: 'left'
        }
      ],
      LookList: [],
      total: 0,
      page: 1,
      size: 10,
      circulateType: 1,
      lookloadIng: false,
      pIsedit: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo, //用户信息
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList, // 用户列表
      GroupList: (state) => state.app.GroupList, // 分组列表
      documentTypeList: (state) => state.bytype.documentTypeList // 发文分类
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱 可编辑
          return false
        }
      }
    }
  },
  created() {
    vm = this
    this.getByType()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.workbench = this.$route.query.workbench
      ? this.$route.query.workbench
      : ''
    if (this.id) {
      if (this.version) {
        this.getHistoryVersionFn()
      } else {
        this.officialDocumentGetFn()
      }
    } else {
      this.Form.drafter = this.$store.state.app.userInfo.id
      this.Form.drafterName = this.$store.state.app.userInfo.fullName
      let date = new Date()
      this.$set(this.Form, 'launchDate', formatDateNoDetails(date))
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  destoryed() {
    this.editor.destory()
  },
  mounted() {
    if (this.$route.query.isEdit === '1') {
      this.isDisabledTrue = !this.isDisabledTrue
      this.wangeditorFn()
    } else {
      this.wangeditorFn()
    }
  },
  methods: {
    //浏览记录弹出
    lookPersonNumber(type) {
      this.circulateType = type
      this.page = 1
      this.getLookList()
      this.visible = true
    },
    // 浏览记录分页
    pageChange(pageber) {
      this.page = pageber
      this.getLookList()
    },
    //获取浏览人数列表
    getLookList() {
      let Pform = {
        circulateType: this.circulateType,
        id: this.id,
        page: this.page,
        size: this.size
      }
      this.lookloadIng = true
      getPersonalCounts(Pform).then((res) => {
        this.lookloadIng = false
        if (res.data.code == 0) {
          this.LookList = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85)
        this.$message.destroy()
        this.$message.warning('只能输入85个字')
      }
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    createWork() {
      //生成work文档
      //生成work文档
      this.WorkLoading = true
      createWord(this.id).then((res) => {
        if (res.data.code == 0) {
          // 查看
          this.WorkLoading = false
          let item = res.data.data
          if (item.fileformat == 'bpmn') {
            this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
          } else {
            let Base64 = require('js-base64').Base64
            window.open(
              item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
            )
          }
        } else {
          this.WorkLoading = false
        }
      })
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '公文发文-' + this.Form.title + this.$printFormatDate(new Date())
    },

    getHistoryVersionFn() {
      getHistoryVersion({ id: this.id, version: this.version }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.upfileList = res.data.data.files
          if (this.Form.personalCounts) {
            //浏览数据存在
            this.personalCounts = this.Form.personalCounts
          }
          setTimeout(() => {
            this.editor.setContent(res.data.data.content)
          }, 600)
        }
      })
    },

    wangeditorFn() {
      // 初始化百度ueditor富文本
      UE.delEditor('editor')
      UE.getEditor('editor', {
        initialFrameWidth: '100%',
        initialFrameHeight: 450, // 设置默认高度
        scaleEnabled: true // 不自动拉伸高度
      })
      this.editor = UE.getEditor('editor', {
        // initialContent: '请输入内容', // 初始化编辑器的内容,也可以通过textarea/script给值
        BaseUrl: '',
        UEDITOR_HOME_URL: vm.$bdPackConfig.baiduEditorUrl,
        autoFloatEnabled: false
      })
      UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl
      UE.Editor.prototype.getActionUrl = function (action) {
        // let ts = this
        if (action === 'upload') {
          return vm.$bdPackConfig.baiduUploadUrl
        } else {
          return this._bkGetActionUrl.call(this, action)
        }
      }
      let ue = UE.getEditor('editor')
      if (!this.isDisabledTrue) {
        // 处理all-editor报错 无法禁用富文本问题
        document.getElementById('edui1_toolbarbox').style.display = 'none'
        ue.ready(function () {
          ue.setDisabled()
        })
      } else {
        ue.ready(function () {
          ue.setEnabled()
        })
      }
    },
    sysHeaderListGian(obj) {
      sysHeaderList(obj).then((res) => {
        this.sysHeaderListData = res.data.data
        if (this.Form.dispatchType == 1) {
          //行政 头固定
          this.$set(this.Form, 'pageHead', this.sysHeaderListData[0].header)
        }
      })
    },
    // 获取页头列表
    serialNumberTypeChange(val) {
      if (val == 2) {
        delete this.Form.serialNumber
      }
      delete this.Form.pageHead
      this.sysHeaderListGian({
        modelType: 1,
        numberType: val,
        administration: this.Form.dispatchType == 1 ? 1 : 2
      })
      this.$forceUpdate
    },
    officialDocumentGetFn() {
      let obj = {
        id: this.id
      }
      if (this.workbench) {
        obj.workbench = this.workbench
      }
      officialDocumentGet(obj).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          // 编辑获取页头
          sysHeaderList({
            modelType: 1,
            numberType: this.Form.serialNumberType,
            administration: this.Form.dispatchType == 1 ? 1 : 2
          }).then((res) => {
            this.sysHeaderListData = res.data.data
          })
          this.upfileList = res.data.data.files
          if (this.Form.personalCounts) {
            //浏览数据存在
            this.personalCounts = this.Form.personalCounts
          }
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
          setTimeout(() => {
            this.editor.setContent(res.data.data.content)
          }, 600)
        }
      })
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.officialDocumentGetFn()
      }
    },
    // 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    ...mapActions([
      'getorganizationUserList',
      'getdocumentType',
      'getqueryUserList',
      'getGroupList'
    ]),
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      this.getorganizationUserList()
      //发文分类
      this.getdocumentType()
      // 用户列表
      this.getqueryUserList()
      // 分组
      this.getGroupList()
    },

    saveFormFn(type) {
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      let officialDocument = this.Form
      officialDocument.files = this.upfileList
      // officialDocument.appId = this.$route.meta.appId
      officialDocument.appId = this.$APPID.DOMAPPID
      officialDocument.skipPageReqFlag = '/OfficialDocumentDetial'
      if (this.id) {
        officialDocumentUpdate(officialDocument).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.officialDocumentGetFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 1) {
                  this.$message.success('保存成功')
                } else {
                  this.$message.success('提交成功')
                  this.goback()
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        officialDocument.companyName = organizationName
        officialDocumentSave(officialDocument).then((res) => {
          if (res.data.code == 0) {
            this.loading = false
            this.confirmLoading = false
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.officialDocumentGetFn()
            }
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    },
    dispatchTypeChange() {
      getUserIds({ documentCategory: this.Form.dispatchType }).then((res) => {
        if (res.data.code == 0) {
          this.Form.signer = res.data.data.issueUserIds + ''
          this.Form.redChromatography = res.data.data.overprintUserIds + ''
          delete this.Form.pageHead
          this.$forceUpdate()
        }
      })
      if (this.Form.serialNumberType) {
        // 编辑获取页头
        sysHeaderList({
          modelType: 1,
          numberType: this.Form.serialNumberType,
          administration: this.Form.dispatchType == 1 ? 1 : 2
        }).then((res) => {
          this.sysHeaderListData = res.data.data
        })
      }
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      this.Form.content = this.editor.getContent()
      if (!this.Form.title) {
        this.$message.error('请添加标题')
        return
      }
      if (!this.Form.dispatchType) {
        this.$message.error('请选择发文类别')
        return
      }
      if (!this.Form.serialNumberType) {
        this.$message.error('请选择发文编号类别')
        return
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加发文单位')
        return false
      }
      if (!this.Form.pageHead) {
        this.$message.error('请添加页头')
        return
      }
      if (!this.Form.postNumber) {
        this.$message.error('请添加发文份数')
        return
      }
      if (!this.Form.groupIds) {
        this.$message.error('请选择主送')
        return
      }
      if (!this.Form.content) {
        this.$message.error('请添加内容')
        return
      }
      this.confirmLoading = true
      this.saveFormFn('保存')
    },
    submitFn() {
      this.Form.content = this.editor.getContent()
      if (!this.Form.title) {
        this.$message.error('请添加标题')
        return
      }
      if (!this.Form.dispatchType) {
        this.$message.error('请选择发文类别')
        return
      }
      if (!this.Form.serialNumberType) {
        this.$message.error('请选择发文编号类别')
        return
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加发文单位')
        return false
      }
      if (!this.Form.pageHead) {
        this.$message.error('请添加页头')
        return
      }
      if (!this.Form.postNumber) {
        this.$message.error('请添加发文份数')
        return
      }
      if (!this.Form.groupIds) {
        this.$message.error('请选择主送')
        return
      }
      if (!this.Form.content) {
        this.$message.error('请添加内容')
        return
      }
      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('添加')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('添加')
          }
        })
      }
    },
    goback() {
      if (this.workbench) {
        this.$router.push('/')
      } else {
        this.$router.push('/officialDocument')
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)
        }
      })
    },
    // 移除
    removeFiles(index) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.upfileList.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },
    goDetial(item) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      this.$message.success('下载中')
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.edui-default {
  width: 857px;
  margin: 0 auto;
}
#FocusZone4 {
  display: none;
}
.offDetial {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;
    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
      position: relative;
      .title-btn {
        position: absolute;
        top: 10px;
        right: 30px;
      }
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .personNumber {
        color: rgba(0, 0, 0, 0.85);
        font-size: 19px;
        cursor: pointer;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.fileDiv {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.whiteSpace {
  white-space: nowrap;
}
</style>
<style lang="scss">
.offDetial {
  .detial-cont {
    .detial-cont-view {
      .ant-descriptions-bordered .ant-descriptions-view {
        border: none;
      }
      .ant-descriptions-view {
        border-radius: 0;
      }
      .ant-descriptions-item-label {
        background: #fff;
      }
      .ant-descriptions-bordered .ant-descriptions-view {
        border-top: rgba(255, 87, 51, 1) solid 1px;
        border-left: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-row {
        border-bottom: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-bordered .ant-descriptions-item-label,
      .ant-descriptions-bordered .ant-descriptions-item-content {
        border-right: rgba(255, 87, 51, 1) solid 1px;
        overflow: hidden;
      }
    }
  }
}
// 打印内容不能嵌套写样式

.Oprintd-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: rgba(255, 87, 51, 1);
}
.Oprintd-cont-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border: 1px solid #cecece;
  padding: 0 23px;
}
.Oprintd-item-span {
  margin-right: 10px;
}
.Oprintd-td {
  .ant-descriptions-view {
    border-radius: 0;
  }
  .ant-descriptions-item-label {
    background: #fff;
  }
  .ant-descriptions-bordered .ant-descriptions-view {
    border-top: rgba(255, 87, 51, 1) solid 1px;
    border-left: rgba(255, 87, 51, 1) solid 1px;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-row {
    border-bottom: rgba(255, 87, 51, 1) solid 1px !important;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-descriptions-bordered .ant-descriptions-item-content {
    border-right: rgba(255, 87, 51, 1) solid 1px !important;
    color: rgba(255, 87, 51, 1);
    overflow: hidden;
  }
}
.Oprintd-item-gw {
  margin-top: 20px;
  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    // border: 1px solid rgba(255, 87, 51, 1);
    color: rgba(255, 87, 51, 1);
  }
}
</style>

<!-- 打印弹窗ant-table的样式  -->
<style scoped src="@/views/OfficialDocument/css/offcialPrintMoadl.css"></style>



// WEBPACK FOOTER //
// src/views/OfficialDocument/detial.vue